module.exports = __webpack_public_path__ + "static/media/microsoft-teams.946fe37b.svg";